// extracted by mini-css-extract-plugin
export var h1 = "styles-module--h1--3pJLn";
export var h2 = "styles-module--h2--3iQ0V";
export var h3 = "styles-module--h3--2joON";
export var h4 = "styles-module--h4--R4PA6";
export var h5 = "styles-module--h5--29K97";
export var body1 = "styles-module--body1--9WDiT";
export var body2 = "styles-module--body2--3V14a";